import sty from './Guide.module.css';

const Guide = () => {
    return (
        <div className="bg">
            <div className="main-container" >
                <div className="page-tit">
                    <div className="page-tit-outer">
                        <p className="page-tit-txt">利用規約</p>
                        <div className="page-tit-border"></div>
                    </div>
                </div>

                <div className="inner-container">
                    <div className={sty['guide__in']}>
                        <div className={sty['guide__in-txt']}>
                            本利用規約（以下「本規約」）は、株式会社ブローウィッシュ（以下「当社」）が提供するWebサービス「EngineerCloud」（以下「本サービス」）の利用条件を定めるものです。ユーザーは本規約に同意した上で本サービスを利用するものとします。
                        </div>
                    </div>

                    <div className={sty['guide__con']}>
                        <div className={sty['guide__tit']}>第1条（適用）</div>
                        <div className={sty['guide__txt']}>
                            <p className={sty['guide__cap']}>
                                本規約は、ユーザーと当社との間の本サービス利用に関わる一切の関係に適用されます。
                            </p>
                        </div>
                    </div>

                    <div className={sty['guide__con']}>
                        <div className={sty['guide__tit']}>第2条（利用登録）</div>
                        <div className={sty['guide__txt']}>
                            <p className={sty['guide__cap']}>
                                ユーザーは、当社所定の方法により利用登録を行います。
                            </p>
                            <p className={sty['guide__cap']}>
                                当社は、登録申請者が不適切と判断した場合、利用登録を拒否することがあります。
                            </p>
                        </div>
                    </div>

                    <div className={sty['guide__con']}>
                        <div className={sty['guide__tit']}>第3条（アカウント管理）</div>
                        <div className={sty['guide__txt']}>
                            <p className={sty['guide__cap']}>
                                ユーザーは、自己の責任においてID・パスワードを管理し、第三者に譲渡・貸与してはなりません。
                            </p>
                            <p className={sty['guide__cap']}>
                                ID・パスワードの不正使用によって生じた損害について、当社は責任を負いません。
                            </p>
                        </div>
                    </div>

                    <div className={sty['guide__con']}>
                        <div className={sty['guide__tit']}>第4条（禁止事項）</div>
                        <div className={sty['guide__txt']}>
                            <p className={sty['guide__cap']}>ユーザーは以下の行為をしてはなりません。</p>
                            <p className={sty['guide__cap']}>(1)法令または公序良俗に違反する行為</p>
                            <p className={sty['guide__cap']}>(2)他者の権利を侵害する行為</p>
                            <p className={sty['guide__cap']}>(3)虚偽情報の登録、なりすまし行為</p>
                            <p className={sty['guide__cap']}>(4)サービス運営を妨害する行為</p>
                            <p className={sty['guide__cap']}>(5)商業的利用（営利目的での無断利用、広告活動）</p>
                            <p className={sty['guide__cap']}>(6)リバースエンジニアリング、セキュリティ脆弱性の探索行為</p>
                        </div>
                    </div>

                    <div className={sty['guide__con']}>
                        <div className={sty['guide__tit']}>第5条（利用停止・登録抹消）</div>
                        <div className={sty['guide__txt']}>
                            <p className={sty['guide__cap']}>
                                当社は、ユーザーが本規約に違反した場合、事前通知なく利用停止または登録抹消できるものとします。
                            </p>
                        </div>
                    </div>

                    <div className={sty['guide__con']}>
                        <div className={sty['guide__tit']}>第6条（サービス提供の変更・停止）</div>
                        <div className={sty['guide__txt']}>
                            <p className={sty['guide__cap']}>
                                当社は、ユーザーへの事前通知なしに、本サービスの内容を変更、中断、終了することができます。
                            </p>
                        </div>
                    </div>

                    <div className={sty['guide__con']}>
                        <div className={sty['guide__tit']}>第7条（免責事項）</div>
                        <div className={sty['guide__txt']}>
                            <p className={sty['guide__cap']}>
                                当社は、本サービスに関連してユーザーに発生した損害について、一切責任を負いません。
                            </p>
                            <p className={sty['guide__cap']}>
                                通信環境・サーバートラブル・クラウドサービス提供者の障害による損害についても同様とします。
                            </p>
                            <p className={sty['guide__cap']}>
                                ユーザー間またはユーザーと第三者との間のトラブルについて、当社は一切関与しません。
                            </p>
                        </div>
                    </div>

                    <div className={sty['guide__con']}>
                        <div className={sty['guide__tit']}>第8条（知的財産権）</div>
                        <div className={sty['guide__txt']}>
                            <p className={sty['guide__cap']}>
                                本サービスに関する著作権・商標権等の知的財産権は当社または正当な権利者に帰属します。
                            </p>
                        </div>
                    </div>

                    <div className={sty['guide__con']}>
                        <div className={sty['guide__tit']}>第9条（規約の変更）</div>
                        <div className={sty['guide__txt']}>
                            <p className={sty['guide__cap']}>
                                当社は必要に応じて本規約を改定することがあります。改定後の規約は、本サービスに掲載された時点で効力を生じます。
                            </p>
                        </div>
                    </div>

                    <div className={sty['guide__con']}>
                        <div className={sty['guide__tit']}>第10条（準拠法・裁判管轄）</div>
                        <div className={sty['guide__txt']}>
                            <p className={sty['guide__cap']}>
                                本規約は日本法を準拠法とし、本サービスに関連する紛争は東京地方裁判所を専属的合意管轄裁判所とします。
                            </p>
                        </div>
                    </div>

                    <div className={sty['guide__con']}>
                        <div className={sty['guide__txt-last']}>
                            <p>2025年9月26日制定</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Guide;
